<template>
    <v-card elevation="0" class="pa-0 ma-0">
        <v-card elevation="0">
            <v-card-title>{{ $t('delivery.surveys.labels.information') }}</v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" sm="6">
                        <h4 style="color: black;">
                            <v-icon color="primary" class="mr-4">short_text</v-icon>{{$t('delivery.surveys.labels.name')}}</h4>
                        <span>{{ item.name }}</span>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <h4 style="color: black;">
                            <v-icon color="primary" class="mr-4">short_text</v-icon>{{$t('delivery.surveys.labels.description')}}</h4>
                        <span>{{ item.description }}</span>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-card elevation="0">
            <v-card-title>{{ $t('delivery.surveys.labels.questions') }}</v-card-title>
            <v-card-text>
                <v-expansion-panels multiple>
                    <v-expansion-panel
                        v-for="(question, questionsIndex) of item.questions"
                        :key="`${question.question}-${questionsIndex}`"
                    >
                        <v-expansion-panel-header>
                            {{ question.question }}
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <h3 class="mb-2">{{ $t('delivery.surveys.labels.options') }}</h3>
                            <div class="d-flex">
                                <v-chip class="mr-2" v-for="(option, optionIndex) of question.options" color="grey" :key="`${option.value}-${optionIndex}`">{{ option.value }}</v-chip>
                            </div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-card-text>
        </v-card>
    </v-card>
</template>
<script>
    export default {
        name: 'SurveyShowData',
        props: {
            item: {type: Object, required: true}
        }
    }
</script>

